
import React, { useEffect, useState } from 'react';
import { Box, Card, Divider, TableBody } from '@mui/material';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Edit from "../../../icons/edit.svg";
import Trash from "../../../icons/trash1.svg";
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { MenuItem, Checkbox, ListItemText } from "@mui/material";
import Select from "@mui/material/Select";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { getGlobalClientId } from "../../../utils/Token";
import axios from '../../../utils/fvAxios';
import { ToastContainer, toast } from 'react-toastify';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Nodata from "../../Nodata/Nodata";
import EyeOff from "../../../icons/Eye Off.svg";
import Eyein from "../../../icons/Eye In.svg";
import { HasScreenPermissions, HasPermissions } from '../../../utils/Token';
import INFO from '../../../pages/commom/RouteUrlInfo.json';
import PER from "../../../utils/Enums.json";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";

export default function SiteTypes() {
  const toastNotify = (message, isSuccess = true) => {
    if (isSuccess) {
      toast.success(message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.action.hover,

    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
      marginBottom: "20px"
    },
  }));

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 50 * 5 + 8,
        width: 250,
      },
    },
  };
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [Clients, setClients] = useState([]);
  const [ClientId, setClientId] = useState("");
  const [Sites, setSites] = useState([]);
  const [SitesInfo, setSitesInfo] = useState([]);
  const [Sitetypes, setSitetypes] = useState([]);
  const [BULocations, setBULocations] = useState([]);
  const [BULocationId, setBULocationId] = useState("");
  const [SafetyRepresentataiveId, setSafetyRepresentataiveId] = useState([]);
  const [SitetypeId, setSitetypeId] = useState("");
  const [unitSiteId, setUnitSiteId] = useState("");
  const [unitId, setUnitId] = useState("");
  const [Refesh, setRefesh] = useState(false);
  const [BUName, setBUName] = useState("");
  const [SiteName, setSiteName] = useState("");

  const [HourstoAutoCheckout, setHourstoAutoCheckout] = useState(null);


  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [id, setID] = useState("");
  const [ids, setIDs] = useState("");

  const handleClickOpen = (num, UnitId, UnitSiteId) => {
    Reset();
    setBUName("");
    setUnitSiteId(UnitSiteId);
    if (num != 5)
      axios.get("SiteManagement/GetDetailsToAddClientBUSite?clientId=" + ClientId + "&siteId=" + UnitSiteId + "&unitId=" + UnitId)
        .then((res) => {
          setSitesInfo(res?.data?.data);
          setSitetypeId(res?.data?.data?.siteType == null ? "" : res?.data?.data?.siteType);
          setBULocationId(res?.data?.data?.businessUnitLocation);
          setSafetyRepresentataiveId(res?.data?.data?.businessUnitSiteSafetyRepresentative);
          setSiteName(res?.data?.data?.businessUnitSiteName);
          setHourstoAutoCheckout(res?.data?.data?.maxAutoCheckoutHours == 0 ? "0" : res?.data?.data?.maxAutoCheckoutHours);

        })
        .catch((err) => {
          console.log(err);
        });
    setID(num);
    setOpen(true);
  };
  const handleClickOpen1 = (num, UnitId, UnitSiteId) => {
    if (num == 4) {
      setUnitId(UnitId);
    } else if (num == 3) {
      setUnitSiteId(UnitSiteId);
    }
    setIDs(num);
    setOpen1(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleClose1 = () => {
    setOpen1(false);
  };

  useEffect(() => {
    Details();
  }, []);


  async function Details() {
    const res = await axios.get("Prequalification/GetAllClients?getAll=false&isIncludeMultiClient=false&ClientIds=" + getGlobalClientId());
    setClients(res?.data?.data);
    const resp = await axios.get("SiteManagement/GetSiteTypes?sitetype=1");
    setSitetypes(resp?.data?.data);
    const response = await axios.get("Common/GetCountryStatesByClientId?country=United%20States&includeCanada=true");
    setBULocations(response?.data?.data);
  }
  const Reset = () => {
    setBULocationId("");
    setSafetyRepresentataiveId([]);
    setSitetypeId("");
    setSiteName("");
    setHourstoAutoCheckout("");
  }
  const ChangeClientId = (e) => {
    setSpinner(!spinner);
    setClientId(e);
    axios.get("SiteManagement/GetSitesForClient?clientId=" + e)
      .then((res) => {
        setSites(res?.data?.data);
        setSpinner(spinner);
      })
      .catch((err) => {
        console.log(err);
      });
  }


  async function DeleteSiteOrUnit() {
    if (ids == 3) {
      const res = await axios.post("SiteManagement/DeleteSite?siteId=" + unitSiteId);
      if (res?.data?.responseCode == 100) {
        toastNotify(res?.data?.data, true)
      } else {
        toastNotify(res?.data?.responseMessage, false)
      }
    } else if (ids == 4) {
      const resp = await axios.post("SiteManagement/DeleteBusinessUnitAndSites?busUnitId=" + unitId);
      if (resp?.data?.responseCode == 100) {
        toastNotify(resp?.data?.data, true)
      } else {
        toastNotify(resp?.data?.responseMessage, false)
      }
    }
    ChangeClientId(ClientId);
    handleClose1();
  }

  async function HideOrUnHideSite(num, val) {
    const isHide = num == 1 ? true : false;
    const res = await axios.post("SiteManagement/HideOrUnhideSite?siteId=" + val + "&isHide=" + isHide);
    if (res?.data?.responseCode == 100) {
      toastNotify(res?.data?.data, true)
    } else {
      toastNotify(res?.data?.responseMessage, false)
    }
    ChangeClientId(ClientId);
  }

  async function HideOrUnHideUnit(num, val) {
    const isHide = num == 1 ? true : false;
    const res = await axios.post("SiteManagement/HideOrUnhideBusinessUnit?businessUnitId=" + val + "&isHide=" + isHide);
    if (res?.data?.responseCode == 100) {
      toastNotify(res?.data?.data, true)
    } else {
      toastNotify(res?.data?.responseMessage, false)
    }
    ChangeClientId(ClientId);
  }



  async function AddNewUnitOrEditSite(val) {
    if (val == 5) {
      if (BUName != "") {
        const data = {
          "clientId": ClientId,
          "businessUnitName": BUName
        }
        const res = await axios.post("SiteManagement/AddClientBusinessUnit", data);
        if (res?.data?.responseCode == 100) {
          toastNotify(res?.data?.data, true);
          handleClose();
        } else {
          toastNotify(res?.data?.responseMessage, false);
        }
      } else {
        toastNotify("Please Enter Mandatory Fields", false);
        setOpen(true);
      }

    } else {
      if (BULocationId != "" && SafetyRepresentataiveId != "" && SitetypeId != "" && SiteName != "") {
        const data = {
          "clientId": ClientId,
          "clientBusinessUnitId": SitesInfo?.clientBusinessUnitId,
          "clientBusinessUnitSiteId": val == 1 && val != 5 ? -1 : unitSiteId,
          "oldBusSiteId": 0,
          "clientSelectedBusinessUnit": SitesInfo?.clientSelectedBusinessUnit,
          "businessUnitSiteName": SiteName,
          "isSiteEdit": val == 1 && val != 5 ? false : true,
          "businessUnitLocation": BULocationId,
          "safetyRepresentataives": null,
          "businessUnitSiteSafetyRepresentative": SafetyRepresentataiveId,
          "siteType": SitetypeId,
          "maxAutoCheckoutHours": HourstoAutoCheckout
        }
        const res = await axios.post("SiteManagement/AddClientBusinessUnitSite", data);
        if (res?.data?.responseCode == 100) {
          toastNotify(res?.data?.data, true);
          handleClose();
          Reset();
        } else {
          toastNotify(res?.data?.responseMessage, false)
        }
      } else {
        toastNotify("Please Enter Mandatory Fields", false);
        setOpen(true);
      }
    }
    ChangeClientId(ClientId);

  }
  const [spinner, setSpinner] = React.useState(false);
  const SpinnerClose = () => {
    setSpinner(false);
  };

  return (
    <>
      <ToastContainer />
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={spinner}
        onClick={SpinnerClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Dialog fullScreen={fullScreen} open={open} onClose={handleClose}>
        <DialogContent sx={{ padding: "48px 48px" }}>
          <DialogTitle
            sx={{
              textAlign: "center",
              fontWeight: 500,
              fontSize: 20,
            }}
          >
            <span style={{ fontSize: "larger" }} >{id != 5 ? (id == 1 ? " Add Site Type " : " Edit Site Type ") : "Add Location(s)/Project(s)"}</span>
          </DialogTitle>

          <DialogActions >

            <div>
              {id != 5 ?
                <div className=''>
                  <div >
                    <span style={{ color: "#3E4A62" }}>Business Unit </span>
                    <br />
                    <TextField
                      placeholder='Business Unit'
                      value={SitesInfo?.clientSelectedBusinessUnit || ""}
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        fontFamily: "Arial, FontAwesome",
                        width: "320px"
                      }}
                      variant="outlined"
                      size="small"
                    />
                  </div>
                  <div >
                    <span style={{ color: "#3E4A62" }}>Site Name (example: Columbus, NE) <span style={{ color: "red" }}>*</span></span>
                    <br />
                    <TextField
                      placeholder='Site Name'
                      value={SiteName || ""}
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        fontFamily: "Arial, FontAwesome",
                        width: "320px"
                      }}
                      variant="outlined"
                      size="small"
                      onChange={(e) => setSiteName(e?.target?.value)}

                    />

                  </div>
                  <div >
                    <span style={{ color: "#3E4A62" }}>Business Unit Location <span style={{ color: "red" }}>*</span></span>
                    <br />
                    <Select
                      sx={{
                        '& legend': { display: 'none' },
                        '& fieldset': { top: 0 },
                        width: "320px"
                      }}
                      labelId="demo-multiple-name-label"
                      value={BULocationId || ""}
                      id="demo-multiple-name"
                      size="small"
                      onChange={(e) => setBULocationId(e.target.value)}
                      MenuProps={MenuProps}
                    >
                      {BULocations?.map((r, i) =>
                        <MenuItem key={i} value={r?.value} sx={{ display: r?.key == "" ? "none" : "block" }}>{r?.key}</MenuItem>
                      )}
                    </Select>
                  </div>

                  <div >
                    <span style={{ color: "#3E4A62" }}>Site Safety Representive <span style={{ color: "red" }}>*</span></span>
                    <br />
                    <Select
                      labelId="docs-label"
                      id="docs-select"
                      multiple
                      size='small'
                      sx={{ width: "320px", overflow: "hidden" }}
                      name="Site Safety Representive"
                      value={SafetyRepresentataiveId || []}
                      MenuProps={MenuProps}
                      renderValue={(selected) =>
                        selected
                          .map((value) => SitesInfo?.safetyRepresentataives?.find((doc) => doc?.value === value)?.text)
                          .filter((value) => value !== undefined)
                          .join(", ")
                      }
                      onChange={(e) => setSafetyRepresentataiveId(e.target.value)}
                    >
                      {SitesInfo?.safetyRepresentataives?.map((r) => (
                        <MenuItem key={r?.value} value={r?.value}>
                          <Checkbox checked={SafetyRepresentataiveId?.indexOf(r?.value) > -1} />
                          <ListItemText primary={r?.text} />

                        </MenuItem>
                      ))}
                    </Select>
                  </div>

                  <div >
                    <span style={{ color: "#3E4A62" }}>Site Type <span style={{ color: "red" }}>*</span></span>
                    <br />
                    <Select
                      sx={{
                        '& legend': { display: 'none' },
                        '& fieldset': { top: 0 },
                        width: "320px"
                      }}
                      labelId="demo-multiple-name-label"
                      value={SitetypeId || ""}
                      id="demo-multiple-name"
                      size="small"
                      onChange={(e) => setSitetypeId(e.target.value)}
                      MenuProps={MenuProps}
                    >
                      {Sitetypes?.map((r) =>
                        <MenuItem key={r?.value} value={r?.value}>{r?.text}</MenuItem>
                      )}
                    </Select>

                  </div>

                  <span style={{ color: "#3E4A62" }}>Auto Check-out (hours) </span>
                  <br />
                  <TextField
                    placeholder='Auto Check-out (hours)'
                    value={HourstoAutoCheckout || ""}
                    sx={{
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                      fontFamily: "Arial, FontAwesome",
                      width: "320px"
                    }}
                    variant="outlined"
                    size="small"
                    // type='number'
                    onChange={(event) => {
                      const value = event.target.value;
                      if (value != "" && /^\d+$/.test(value) && value <= 24) {
                        setHourstoAutoCheckout(value);
                      } else {
                        setHourstoAutoCheckout(null);
                      }
                    }}

                  />

                </div>
                :
                <div>
                  <span style={{ color: "#3E4A62" }}>Business Unit Name<span style={{ color: "red" }}>*</span> </span>
                  <br />
                  <TextField
                    placeholder='Business Unit'
                    value={BUName}
                    sx={{
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                      fontFamily: "Arial, FontAwesome",
                      width: "320px"
                    }}
                    variant="outlined"
                    size="small"
                    onChange={(e) => setBUName(e?.target?.value)}
                  />
                </div>}

              <DialogActions >
                <div className="login-help__buttonContainer mt-4">
                  <Button variant="contained" className="login-help-button-cancel mx-2" onClick={handleClose}>Cancel</Button>
                  {id == 1 ? <Button variant="contained" className="login-button-request mx-2" onClick={() => AddNewUnitOrEditSite(1)}>Add </Button>
                    : id == 5 ? <Button variant="contained" className="login-button-request mx-2" onClick={() => AddNewUnitOrEditSite(5)}>Add </Button>
                      : <Button variant="contained" className="login-button-request mx-2" onClick={() => AddNewUnitOrEditSite(2)}> Save</Button>}

                </div>

              </DialogActions>
            </div >
          </DialogActions>


        </DialogContent>
      </Dialog>

      <Dialog fullScreen={fullScreen} open={open1} onClose={handleClose1}>
        <DialogContent sx={{ padding: "48px 48px" }}>
          <DialogTitle
            sx={{
              textAlign: "center",
              fontWeight: 500,
              fontSize: 20,
            }}
          >
            <span style={{ fontSize: "larger" }} >{ids == 3 ? " Delete Site  " : " Delete Unit "}</span>
          </DialogTitle>

          <DialogActions >
            <div>
              {ids == 3 ? "Are you sure do you want to delete this site?" : "Are you sure do you want to delete this unit?"}
              <DialogActions >
                <div className="login-help__buttonContainer mt-4">
                  <Button variant="contained" className="login-help-button-cancel mx-2" onClick={handleClose1}>Cancel</Button>
                  <Button variant="contained" className="login-button-request mx-2" onClick={DeleteSiteOrUnit}>Delete</Button>
                </div>
              </DialogActions>
            </div >
          </DialogActions>


        </DialogContent>
      </Dialog>

      <div >
        <span style={{ color: "#3E4A62" }}>Client <span style={{ color: "red" }}>*</span></span>
        <br />
        <Select
          sx={{
            "& legend": { display: "none" },
            "& fieldset": { top: 0 },
            width: "330px"
          }}
          value={ClientId}
          required
          size="small"
          placeholder="Role For"
          name="RoleFor"
          id="RoleFor"
          MenuProps={MenuProps}
          className="form-control text-feild-custom "
          onChange={(e) => ChangeClientId(e.target.value)}
        >
          {Clients?.map((r, index) => (
            <MenuItem key={index} title={r?.text} value={r?.value} sx={{ display: r?.text == "" ? "none" : "block" }}>
              {r?.text}
            </MenuItem>
          ))}
        </Select>

        <div style={{ padding: "10px", float: "right", display: !ClientId ? "none" : "block" }}>
          {!HasScreenPermissions(INFO?.AddClientBusinessUnit?.actionName) &&
            <Button variant="contained" startIcon={<AddIcon sx={{ fontSize: 15 }} />} sx={{ padding: "inherit" }} onClick={() => handleClickOpen(5, "", "")}> Add New Unit</Button>
          }
        </div>

      </div>
      <br />
      {!ClientId ?
        <Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" sx={{ padding: 2, marginTop: 4, marginRight: "12px", width: "auto" }} className="text-center">
          <span style={{ color: "#667085" }}>Please Select Client</span>
        </Box> : <>
          {Sites?.length < 1 ? <div hidden={spinner}><Nodata /> </div> : Sites?.map((r, i) => (
            <Card key={i} style={{ marginTop: "10px" }}>
              <div style={{ marginLeft: "15px", marginBottom: "15px", marginTop: "10px" }}>
                <Stack spacing={2} direction="row">
                  <h3 style={{ textDecoration: r?.isDeleted == true ? "line-through" : "" }}>{r?.businessUnitName}</h3>
                  <div style={{ marginLeft: "Auto", padding: "10px" }}>
                    {!HasScreenPermissions(INFO?.AddClientBusinessUnitSite?.actionName) &&
                      <Button variant="contained" disabled={r?.isDeleted == true ? true : false} startIcon={<AddIcon sx={{ fontSize: 15 }} />} sx={{ padding: "inherit" }} onClick={() => handleClickOpen(1, r?.clientBusinessUnitId, -1, "")}> Add New Site</Button>
                    }
                  </div>

                  <div style={{ padding: "10px", display: "flex", gap: "10px" }}>
                    {r?.isDeleted != true ?
                      <Button
                        variant="contained"
                        startIcon={<VisibilityOffIcon fontSize="small" />}
                        sx={{
                          backgroundColor: "#FFFFFF",
                          color: "#667085",
                          "&:hover": {
                            backgroundColor: "#FFFFFF",
                          },
                          border: "1px solid #E4E7EC"
                        }}
                        onClick={() => HideOrUnHideUnit(1, r?.clientBusinessUnitId)}

                      >
                        Hide
                      </Button>
                      :

                      <Button
                        variant="contained"
                        startIcon={<VisibilityIcon fontSize="small" />}
                        sx={{
                          backgroundColor: "#F2F4F7",
                          color: "#667085",
                          "&:hover": {
                            backgroundColor: "#F2F4F7",
                          },
                          border: "1px solid #E4E7EC"
                        }}
                        onClick={() => HideOrUnHideUnit(2, r?.clientBusinessUnitId)}

                      >
                        Unhide
                      </Button>
                    }
                  </div>

                  <div style={{ padding: "10px" }}>
                    {HasPermissions(INFO?.AddClientBusinessUnit?.actionName, PER?.ScreenPermissions?.Delete) &&
                      <Button variant="contained" startIcon={<DeleteIcon sx={{ fontSize: 15 }} />} color="error" sx={{ padding: "inherit" }} onClick={() => handleClickOpen1(4, r?.clientBusinessUnitId, "")}>Delete Unit</Button>
                    }
                  </div>
                </Stack >
              </div>

              <Box sx={{ backgroundColor: '#f8f9fa' }}>
                <TableContainer component={Paper} sx={{ borderBottom: 0 }}>
                  <Table aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}>Site Name</span>	</StyledTableCell>
                        <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}>Representative(s)</span></StyledTableCell>
                        <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}>Location</span></StyledTableCell>
                        <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}>Site Type</span></StyledTableCell>
                        <StyledTableCell >&nbsp;</StyledTableCell>
                        <StyledTableCell >&nbsp;</StyledTableCell>
                        <StyledTableCell >&nbsp;</StyledTableCell>


                      </TableRow>
                    </TableHead>


                    {r?.localClientBUSitesList.map((p, index) => (
                      <TableBody key={index}>

                        <TableRow key={index} >

                          <StyledTableCell sx={{ width: "30%" }}>
                            <span style={{ fontSize: "16px", color: "#101828", textDecoration: p?.isDeleted == true ? "line-through" : "" }}>
                              {p?.siteName}
                            </span>
                          </StyledTableCell>

                          <StyledTableCell sx={{ width: "25%" }}>
                            <span>{p?.localSafetyRepList?.map((q) => q?.name).join(" ,")}<br /></span>

                          </StyledTableCell>

                          <StyledTableCell sx={{ width: "25%" }}>
                            {p?.siteLocation}
                          </StyledTableCell>
                          <StyledTableCell sx={{ width: "25%" }} >
                            <Stack direction="row" spacing={2}>
                              <Card
                                sx={{
                                  width: "15px",
                                  textAlign: "center",
                                  backgroundColor: "#667085",
                                  marginRight: "5px",
                                  color: "#fff",
                                }}
                              >
                                {p?.siteTypeId == "1" ? "L" : "P"}
                              </Card>
                              {p?.siteTypeId == "1" ? "Location" : "Project"}
                            </Stack>
                          </StyledTableCell>

                          <StyledTableCell sx={{ width: "20%%" }} >
                            {HasPermissions(INFO?.AddClientBusinessUnitSite?.actionName, PER?.ScreenPermissions?.Modify) && (
                              <>
                                {p?.isDeleted != true ?
                                  <IconButton aria-label="edit" onClick={() => handleClickOpen(2, r?.clientBusinessUnitId, p?.clientBusinessUnitSiteId)}>
                                    <img src={Edit} alt="editicon" />
                                  </IconButton>
                                  : <IconButton aria-label="edit">
                                    <img src={Edit} alt="editicon" />
                                  </IconButton>}
                              </>)}
                          </StyledTableCell>

                          <StyledTableCell sx={{ width: "20%" }} >
                            {HasPermissions(INFO?.AddClientBusinessUnitSite?.actionName, PER?.ScreenPermissions?.Delete) && (
                              <>
                                {p?.isDeleted != true ?
                                  <IconButton aria-label="eyeoff" disabled={r?.isDeleted == true} onClick={() => HideOrUnHideSite(1, p?.clientBusinessUnitSiteId)}>
                                    <img src={EyeOff} alt="eyeoff" style={{
                                      opacity: r?.isDeleted == true ? 0.4 : 1,
                                    }} />
                                  </IconButton>
                                  : <IconButton aria-label="eye" disabled={r?.isDeleted == true} onClick={() => HideOrUnHideSite(2, p?.clientBusinessUnitSiteId)} >
                                    <img src={Eyein} alt="eye" style={{
                                      opacity: r?.isDeleted == true ? 0.4 : 1,
                                    }} />
                                  </IconButton>
                                }
                              </>)}
                          </StyledTableCell>

                          <StyledTableCell sx={{ width: "20%" }}>
                            <IconButton aria-label="trashicon" onClick={() => handleClickOpen1(3, "", p?.clientBusinessUnitSiteId)}>
                              <img src={Trash} alt="trashicon" />
                            </IconButton>
                          </StyledTableCell>




                        </TableRow>

                      </TableBody>
                    ))}

                  </Table>

                </TableContainer>
              </Box >

            </Card>

          ))}
        </>}
    </>
  )
}


